/**
 * HTML utility functions
 */

/**
 * Escapes HTML special characters in a string for safe use in HTML attributes or content
 * @param {string} text - The text to escape
 * @returns {string} The escaped text
 * @throws {TypeError} If text is not a string
 */
export function escapeHtml(text) {
  if (typeof text !== 'string') {
    throw new TypeError(`escapeHtml expects a string, got ${typeof text}`);
  }

  const escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    // eslint-disable-next-line quotes
    "'": '&#39;',
  };

  return text.replace(/[&<>"']/g, (char) => escapeMap[char]);
}
